var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "manageBox"
  }, [_vm._l(_vm.mouseArray, function (item, key) {
    return _c('div', {
      key: key,
      staticClass: "mouseBox",
      style: _vm.returnStyle(item),
      attrs: {
        "title": item.email
      }
    }, [_c('i', {
      staticClass: "el-icon-position",
      class: _vm.returnMouseColor(item.email)
    }), _c('span', {
      staticClass: "email",
      class: _vm.returnMouseColor(item.email)
    }, [_vm._v(_vm._s(item.email))])]);
  }), _vm.config.urlInfo && _vm.config.urlInfo.userAuthUrl ? _c('tvu-top-header', {
    attrs: {
      "projectName": "Partyline",
      "tvuLogo": true,
      "globalFunList": ['waffle', 'account', 'helpCenter', 'headerTime'],
      "userAuthUrl": _vm.config.urlInfo && _vm.config.urlInfo.userAuthUrl || '',
      "theme": _vm.isDark ? 'dark' : 'light',
      "serviceVesion": [{
        serviceName: 'Partyline',
        frontendVersion: _vm.fontVersion,
        backendVersion: _vm.backendVersion,
        tagName: _vm.applicationName
      }]
    },
    on: {
      "callback": _vm.topHeaderCallback
    },
    scopedSlots: _vm._u([{
      key: "account-center-module",
      fn: function () {
        return [_c('div', {
          staticClass: "contaniner login-info"
        }, [_c('div', {
          staticClass: "collaborate commonLi",
          on: {
            "click": _vm.showCollaborate
          }
        }, [_c('div', {
          staticClass: "left"
        }, [_vm._v(" " + _vm._s(_vm.$t("personalInfo.collaborate")) + " "), _c('span', {
          staticClass: "info"
        }, [_c('el-tooltip', {
          attrs: {
            "popper-class": "collaborate",
            "placement": "bottom",
            "visible-arrow": false
          }
        }, [_c('i', {
          staticClass: "iconfont icon-help2"
        }), _c('div', {
          attrs: {
            "slot": "content"
          },
          slot: "content"
        }, [_c('div', {
          staticClass: "text"
        }, [_vm._v(_vm._s(_vm.$t("personalInfo.addEmailTile")))]), _c('p', {
          staticClass: "text"
        }, [_vm._v(_vm._s(_vm.$t("personalInfo.liveWithAccount")))]), _c('p', {
          staticClass: "text"
        }, [_vm._v(_vm._s(_vm.$t("personalInfo.moveAccount")))]), _c('p', {
          staticClass: "text"
        }, [_vm._v(_vm._s(_vm.$t("personalInfo.pullAccount")))])])])], 1)]), _c('div', {
          staticClass: "right"
        }, _vm._l(_vm.hadInvite, function (item, index) {
          return _c('span', {
            key: index,
            staticClass: "invitedPerson"
          }, [_vm._v(_vm._s(item))]);
        }), 0)]), _c('div', {
          staticClass: "enterReceivedCohost commonLi",
          on: {
            "click": _vm.showReceivedPop
          }
        }, [_c('div', [_c('div', {
          staticStyle: {
            "display": "inline"
          }
        }, [_vm._v(_vm._s(_vm.$t('personalInfo.receivedCohost')))]), _c('span', {
          staticClass: "info",
          staticStyle: {
            "margin-left": "5px"
          }
        }, [_c('el-tooltip', {
          attrs: {
            "popper-class": "collaborate",
            "placement": "bottom",
            "visible-arrow": false
          }
        }, [_c('i', {
          staticClass: "iconfont icon-help2",
          staticStyle: {
            "color": "#6D6D6D"
          }
        }), _c('div', {
          attrs: {
            "slot": "content"
          },
          slot: "content"
        }, [_c('p', {
          staticClass: "text"
        }, [_vm._v(_vm._s(_vm.$t("personalInfo.receivedCohostTextOne")))]), _c('p', {
          staticClass: "text"
        }, [_vm._v(_vm._s(_vm.$t("personalInfo.receivedCohostTextSecond")))])])])], 1)])]), _c('div', {
          staticClass: "usageService commonLi"
        }, [_c('a', {
          attrs: {
            "href": _vm.openUsagePage,
            "target": "_blank"
          }
        }, [_vm._v(_vm._s(_vm.$t('common.usageService')))])]), _vm.$cm.switchLang ? _c('div', {
          staticClass: "language commonLi"
        }, [_c('div', {
          staticClass: "left"
        }, [_vm._v(" " + _vm._s(_vm.$t('personalInfo.lang')) + " ")]), _c('div', {
          staticClass: "right"
        }, [_c('span', {
          class: {
            active: _vm.$i18n.locale === 'en'
          },
          on: {
            "click": function ($event) {
              return _vm.changeLanguage('en');
            }
          }
        }, [_vm._v("EN")]), _c('span', {
          staticClass: "second"
        }, [_vm._v("/")]), _c('span', {
          class: {
            active: _vm.$i18n.locale === 'zh'
          },
          on: {
            "click": function ($event) {
              return _vm.changeLanguage('zh');
            }
          }
        }, [_vm._v("中文")])])]) : _vm._e(), _c('div', {
          staticClass: "theme commonLi"
        }, [_c('div', {
          staticClass: "left"
        }, [_vm._v(" " + _vm._s(_vm.$t('common.theme')) + " ")]), _c('div', {
          staticClass: "right"
        }, [_c('span', {
          class: {
            active: _vm.isDark
          },
          on: {
            "click": function ($event) {
              return _vm.setTheme('dark');
            }
          }
        }, [_vm._v(_vm._s(_vm.$t('common.dark')))]), _c('span', {
          staticClass: "second"
        }, [_vm._v("/")]), _c('span', {
          class: {
            active: !_vm.isDark
          },
          on: {
            "click": function ($event) {
              return _vm.setTheme('light');
            }
          }
        }, [_vm._v(_vm._s(_vm.$t('common.light')))])])])])];
      },
      proxy: true
    }], null, false, 2717928208)
  }) : _vm._e(), _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "contentLeft center"
  }, _vm._l(_vm.tabList, function (item) {
    return _c('div', {
      key: item.name,
      staticClass: "text",
      on: {
        "click": function ($event) {
          return _vm.saveModule(item);
        }
      }
    }, [_c('div', {
      staticClass: "bgBox",
      class: {
        active: item.name == _vm.currentModule
      }
    }, [_c('i', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: item.name == 'party',
        expression: "item.name=='party'"
      }],
      staticClass: "iconfont icon-a-commonparty"
    }), _c('i', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: item.name == 'group',
        expression: "item.name=='group'"
      }],
      staticClass: "iconfont icon-Galleryview"
    }), _c('i', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: item.name == 'coordinator',
        expression: "item.name=='coordinator'"
      }],
      staticClass: "iconfont icon-Conference"
    }), _c('i', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: item.name == 'kiosk',
        expression: "item.name=='kiosk'"
      }],
      staticClass: "iconfont icon-Kiosk"
    }), _c('i', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: item.name == 'globalControl',
        expression: "item.name=='globalControl'"
      }],
      staticClass: "iconfont icon-a-globalcontrol"
    }), _c('i', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: item.name == 'interview',
        expression: "item.name=='interview'"
      }],
      staticClass: "iconfont icon-a-interview"
    })]), _c('span', {
      staticClass: "title",
      class: {
        greenColor: item.name == _vm.currentModule
      }
    }, [_vm._v(_vm._s(_vm.$t(`commonPartyHost.leftPane.title.${item.name}`)))])]);
  }), 0), _c('div', {
    staticClass: "contentRight"
  }, [_vm.currentModule != 'globalControl' ? _c('partyInfo', {
    attrs: {
      "currentModule": _vm.currentModule
    }
  }) : _c('new-global-control')], 1)]), _c('TipsDailog', {
    staticClass: "collaborate",
    attrs: {
      "info": _vm.collaborateInfo,
      "width": "640px"
    },
    on: {
      "open": _vm.getInvitedList,
      "close": _vm.closeCollaborate
    }
  }, [_c('el-tabs', {
    on: {
      "tab-click": _vm.getInvitedList
    },
    model: {
      value: _vm.selectType,
      callback: function ($$v) {
        _vm.selectType = $$v;
      },
      expression: "selectType"
    }
  }, [_c('el-tab-pane', {
    attrs: {
      "label": _vm.$t('personalInfo.inviteCollaborators'),
      "name": "invitedOther"
    }
  }, [_c('div', {
    staticClass: "inviteBox"
  }, [_c('div', {
    staticClass: "userListBox"
  }, [_c('i', {
    staticClass: "el-icon-user-solid m_r_20"
  }), _c('el-input', {
    ref: "emailInput",
    class: {
      redBorder: _vm.showErrorEmailText
    },
    attrs: {
      "placeholder": _vm.$t('invite.invitePlaceholder'),
      "clearable": ""
    },
    on: {
      "input": _vm.checkInputText
    },
    nativeOn: {
      "keyup": function ($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) return null;
        return _vm.saveCollaborate.apply(null, arguments);
      }
    },
    model: {
      value: _vm.collaborateSearchName,
      callback: function ($$v) {
        _vm.collaborateSearchName = $$v;
      },
      expression: "collaborateSearchName"
    }
  }), _c('el-button', {
    on: {
      "click": _vm.saveCollaborate
    }
  }, [_vm._v(_vm._s(_vm.$t('addTvuOne.adds')))])], 1), _vm.showErrorEmailText ? _c('div', {
    staticClass: "redColor emailWarn"
  }, [_vm._v("* " + _vm._s(_vm.$t('invite.emailCorrectly')))]) : _vm._e(), _c('div', {
    directives: [{
      name: "scroll",
      rawName: "v-scroll",
      value: _vm.collaborateScroll,
      expression: "collaborateScroll"
    }],
    staticClass: "hadInviteList scrollbar gray"
  }, [_vm._l(_vm.willInviteCollaborate, function (user, index) {
    return _c('div', {
      key: user.name,
      staticClass: "li"
    }, [_c('span', {
      staticClass: "firstName",
      class: user.color
    }, [_vm._v(_vm._s(user.name ? user.name.slice(0, 1) : ''))]), _c('span', {
      staticClass: "emailContent"
    }, [_vm._v(_vm._s(user.name))]), _c('el-popover', {
      attrs: {
        "placement": "bottom-start",
        "width": "200",
        "trigger": "hover",
        "popper-class": "remove"
      }
    }, [_c('i', {
      staticClass: "el-icon-more right",
      attrs: {
        "slot": "reference"
      },
      slot: "reference"
    }), _c('span', {
      staticClass: "pointer",
      on: {
        "click": function ($event) {
          return _vm.removeCollaborateInvite(index);
        }
      }
    }, [_vm._v(_vm._s(_vm.$t('invite.remove')))])])], 1);
  }), _vm.willInviteCollaborate.length ? _c('el-divider') : _vm._e(), _vm._l(_vm.hadInviteCollaborate, function (user, index) {
    return _c('div', {
      key: user.collaborateEmail,
      staticClass: "li"
    }, [_c('span', {
      staticClass: "firstName",
      class: user.color
    }, [_vm._v(_vm._s(user.collaborateEmail ? user.collaborateEmail.slice(0, 1) : ''))]), _c('span', {
      staticClass: "emailContent",
      class: {
        declined: user.status === 2
      }
    }, [_vm._v(_vm._s(user.collaborateEmail))]), _c('el-tooltip', {
      staticClass: "item",
      attrs: {
        "effect": "dark",
        "content": _vm.$t('personalInfo.pending'),
        "placement": "top-start"
      }
    }, [user.status === 0 ? _c('span', {
      staticClass: "right",
      staticStyle: {
        "margin-left": "15px",
        "color": "#909090"
      }
    }, [_vm._v(_vm._s(_vm.$t("personalInfo.inviting")))]) : _vm._e()]), user.status === 2 ? _c('span', {
      staticClass: "right",
      staticStyle: {
        "margin-left": "15px",
        "color": "#909090"
      }
    }, [_vm._v(_vm._s(_vm.$t("personalInfo.declined")))]) : _vm._e(), _c('el-popover', {
      attrs: {
        "placement": "bottom-start",
        "width": "200",
        "trigger": "hover",
        "popper-class": "remove"
      }
    }, [_c('i', {
      staticClass: "el-icon-more right",
      attrs: {
        "slot": "reference"
      },
      slot: "reference"
    }), _c('span', {
      staticClass: "pointer",
      on: {
        "click": function ($event) {
          return _vm.deleteCollaborateInvite(user.collaborateUserId, index);
        }
      }
    }, [_vm._v(_vm._s(_vm.$t('invite.remove')))])])], 1);
  })], 2)])]), _c('el-tab-pane', {
    attrs: {
      "label": _vm.$t('personalInfo.receivedInvites'),
      "name": "invitedByOther"
    }
  }, [_c('el-table', {
    directives: [{
      name: "scroll",
      rawName: "v-scroll",
      value: _vm.receiverCollaborateScroll,
      expression: "receiverCollaborateScroll"
    }],
    staticClass: "invitedMe",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.invitedMeList,
      "default-sort": {
        prop: 'date',
        order: 'descending'
      }
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "userEmail",
      "label": "",
      "width": "60"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function (scope) {
        return [_c('div', {
          staticClass: "participant firstName",
          class: scope.row.color
        }, [_vm._v(_vm._s(scope.row.userEmail ? scope.row.userEmail.slice(0, 1) : ''))])];
      }
    }])
  }), _c('el-table-column', {
    attrs: {
      "prop": "userEmail",
      "label": _vm.$t('personalInfo.applicant'),
      "width": "180"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function (scope) {
        return [_c('div', {
          staticClass: "email",
          class: {
            decline: scope.row.status == '2'
          },
          attrs: {
            "title": scope.row.userEmail
          }
        }, [_vm._v(_vm._s(scope.row.userEmail))])];
      }
    }])
  }), _c('el-table-column', {
    attrs: {
      "sortable": "",
      "prop": "createTime",
      "width": "160",
      "label": _vm.$t('personalInfo.inviteationTime')
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function (scope) {
        return [_c('div', [_vm._v(_vm._s(_vm.showInvitedTime(scope.row.createTime)))])];
      }
    }])
  }), _c('el-table-column', {
    attrs: {
      "prop": "status",
      "width": "120",
      "label": _vm.$t('personalInfo.Permission')
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function (scope) {
        return [_c('span', {
          class: {
            pedding: scope.row.status == '0'
          }
        }, [_vm._v(_vm._s(_vm.returnText(scope.row)))]), _c('el-select', {
          attrs: {
            "popper-class": "permission"
          },
          on: {
            "change": result => {
              _vm.controlPermission(result, scope.row);
            }
          },
          model: {
            value: scope.row.select,
            callback: function ($$v) {
              _vm.$set(scope.row, "select", $$v);
            },
            expression: "scope.row.select"
          }
        }, _vm._l(_vm.options, function (item) {
          return _c('el-option', {
            key: item.value,
            attrs: {
              "label": _vm.$t(`personalInfo.${item.label}`),
              "value": item.value
            }
          });
        }), 1)];
      }
    }])
  }), _c('el-table-column', {
    attrs: {
      "label": ""
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function (scope) {
        return [_c('el-popover', {
          attrs: {
            "placement": "bottom-start",
            "width": "200",
            "trigger": "hover",
            "popper-class": "remove"
          }
        }, [_c('i', {
          staticClass: "el-icon-more right pointer",
          attrs: {
            "slot": "reference"
          },
          slot: "reference"
        }), _c('span', {
          staticClass: "pointer",
          on: {
            "click": function ($event) {
              return _vm.deleteCollaborateByOtherInvite(scope.row);
            }
          }
        }, [_vm._v(_vm._s(_vm.$t('invite.remove')))])])];
      }
    }])
  })], 1)], 1)], 1)], 1)], 2);
};
var staticRenderFns = [];
export { render, staticRenderFns };